const mytrendsList = [
  {
    pic: require('../image/Trends/trends1.webp'),
    title: '国医通近期完成融资，推动基层血透服务、工业拓展和信息化建设',
    content:
      '国医通(北京)科技发展有限公司（以下简称“国医通”）今日宣布完成A+融资，本轮融资由楹联资本独家领投。BFC Group担任本次融资的独家财务顾问。',
    year: '2022/01',
    day: '10',
    link: 'https://mp.weixin.qq.com/s/6qUPtzpg_x0u9UpMbgcrHg',
  },
  {
    pic: require('../image/Trends/trends2.webp'),
    title: '国家卫健委继教中心主办“透析专项培训”第三期开始招生',
    content:
      '国家卫生健康委能力建设和继续教育中心于近日发布了“透析综合管理能力建设专项培训”第三期培训通知。该项目由卫健委继教中心主办，北京大学人民医院肾内科主任左力教授牵头，组建国家级...',
    year: '2021/06',
    day: '10',
    link: 'https://mp.weixin.qq.com/s/i84dOvaWIMIvSY5ayBkbWg',
  },
  {
    pic: require('../image/Trends/trends3.webp'),
    title: '第四届全国科技工作者日：为肾脏健康保驾护航-延缓肾病进展和...',
    content: '为肾脏健康保驾护航-延缓肾病进展和选择透析模式系列',
    year: '2020/05',
    day: '29',
    link: 'https://mp.weixin.qq.com/s/KmyBM2RkWB5mJKBO0ZiWsQ',
  },
  {
    pic: require('../image/Trends/trends4.webp'),
    title: '国医通向社会捐赠抗击疫情物资',
    content:
      '新冠疫情期间，国医通（北京）科技发展有限公司于2020年2月16日通过红十字会，向哈尔滨政府捐赠价值 301万元的生命体征监测设备...',
    year: '2019/04',
    day: '20',
    link: 'https://mp.weixin.qq.com/s/FmnmF0Q8ckuFdPeMpBWgUg',
  },
  {
    pic: require('../image/Trends/trends5.jpg'),
    title: '国医通（北京）科技发展有限公司与吉林正大国际医院合作的血...',
    content:
      '正大国际医院是正大制药集团投资的、以心脏内外诊疗为核心业务、开展常见病、多发病常规医疗服务、慢性病管理等现代新医学模式的小综合、大专科的高端现代化医疗服务机构。',
    year: '2018/05',
    day: '12',
    link: '',
  },
  
]

export default mytrendsList
